import * as Survey from 'survey-react';
import { configureSurveyModelForDatasets } from './datasets';
import './survey-overlay-fix.css';

export const configureSurvey = async (Survey: any, SurveyCreator?: any) => {
  const isCreator = SurveyCreator !== undefined;

  if (isCreator) {
    Survey.Serializer.findProperty('survey', 'title').isRequired = true;
    Survey.Serializer.findProperty('survey', 'clearInvisibleValues').defaultValue = 'onComplete';
  }

  Survey.Serializer.addProperties('question', [
    {
      name: 'questionNumber',
      category: 'general',
    },
    {
      name: 'tag',
      category: 'general',
    },
  ]);

  if (isCreator) {
    SurveyCreator.SurveyQuestionEditorDefinition.definition['question'].properties = [
      'title',
      'name',
      {
        name: 'questionNumber',
        title: 'Question Number',
      },
    ];
    Survey.Serializer.findProperty('question', 'tag').readOnly = true;
  }
};

export const configureSurveyModel = async (
  model: Survey.Model,
  previewMode: boolean | undefined,
  saveSurvey: (model: Survey.SurveyModel) => Promise<void>
) => {
  model.onComplete.add(saveSurvey);
  model.showCompletedPage = previewMode ? false : true;
  model.onCompleting.add((sender: any, options: any) => {
    options.allowComplete = !previewMode;
  });
};

export const configureSurveyDropdowns = (model: Survey.Model) => {
  const enableDropdownSearch = (question: any) => {
    if (question && question.getType && question.getType() === 'dropdown') {
      question.searchEnabled = true;
    }
  };

  model.getAllQuestions().forEach(enableDropdownSearch);

  model.onQuestionCreated.add((_, options: any) => {
    enableDropdownSearch(options.question);
  });
};

export const configureSurveyCreator = async (
  surveyCreator: any,
  saveSurvey: (surveyCreator: any, saveOnly?: boolean) => Promise<void>,
  onCancel: () => void | undefined,
  data: any | undefined
) => {
  surveyCreator.saveSurveyFunc = async () => {
    await saveSurvey(surveyCreator);
  };
  surveyCreator.rightContainerActiveItem('toolbox');
  surveyCreator.showToolbox = 'right';
  surveyCreator.showPropertyGrid = 'right';

  surveyCreator.toolbarItems().find((item: any) => item.id === 'svd-save').title = 'Save + Exit';

  const saveAndExitButtonIndex = surveyCreator
    .toolbarItems()
    .map((item: any) => item.id)
    .indexOf('svd-save');

  surveyCreator.toolbarItems.splice(saveAndExitButtonIndex, 0, {
    id: 'custom-save',
    visible: true,
    title: 'Save',
    action: () => saveSurvey(surveyCreator, true),
  });

  surveyCreator.toolbarItems.push({
    id: 'custom-cancel',
    visible: true,
    title: 'Cancel',
    action: onCancel,
  });

  var questionCounter = 1;
  surveyCreator.onQuestionAdded.add((surveyCreator: any, options: { question: Survey.Question }) => {
    var q = options.question;
    var t = q.getType();
    q.name = 'Question' + t[0].toUpperCase() + t.substring(1) + questionCounter;
    q['tag'] = generateTag();
    questionCounter++;
  });

  surveyCreator.onPageAdded.add((surveyCreator: any, options: { page: Survey.PageModel }) => {
    options.page.questions &&
      options.page.questions.forEach((question: Survey.Question) => {
        var qst = question;
        qst['tag'] = generateTag();
      });
  });

  //surveyCreator.onPreviewSurveyCreated.add((surveyCreator: any, options: { survey: Survey.Survey}) => {
  surveyCreator.onTestSurveyCreated.add(async (surveyCreator: any, options: any) => {
    const survey = options.survey as Survey.Survey;
    await configureSurveyModelForDatasets(survey);
  });

  surveyCreator.JSON = data;
};

const generateTag = (): string => {
  const s4 = (): string => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};
